import { render, staticRenderFns } from "./UpperLimitTable.vue?vue&type=template&id=2a65c472&scoped=true"
import script from "./UpperLimitTable.vue?vue&type=script&lang=js"
export * from "./UpperLimitTable.vue?vue&type=script&lang=js"
import style0 from "./UpperLimitTable.vue?vue&type=style&index=0&id=2a65c472&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a65c472",
  null
  
)

export default component.exports